var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsercarEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47899 16.9678C6.41695 16.9685 6.35538 16.9569 6.29785 16.9337C6.24031 16.9105 6.18794 16.8761 6.14374 16.8327C6.09307 16.7827 6.05408 16.7222 6.02956 16.6554C6.00504 16.5887 5.99559 16.5173 6.0019 16.4465L6.20176 13.9751C6.21033 13.8603 6.2608 13.7527 6.3436 13.6726L13.4742 6.55449C13.8715 6.18308 14.4001 5.98405 14.9442 6.001C15.4847 6.00519 16.0034 6.21459 16.3948 6.58667C16.7703 6.97154 16.9862 7.48381 16.9994 8.02087C17.0125 8.55793 16.8219 9.08011 16.4657 9.48284L9.32866 16.6332C9.24879 16.7126 9.14419 16.7625 9.03209 16.7747L6.52412 17L6.47899 16.9678ZM7.12372 14.2261L6.98832 15.9896L8.75486 15.8287L15.7823 8.80063C15.9193 8.63875 16.0069 8.44101 16.0347 8.23091C16.0624 8.0208 16.0292 7.80716 15.9389 7.61536C15.8486 7.42356 15.705 7.26166 15.5253 7.1489C15.3455 7.03615 15.1371 6.97727 14.9249 6.97926C14.7853 6.97042 14.6454 6.9898 14.5136 7.03625C14.3818 7.0827 14.2607 7.15526 14.1576 7.24957L7.12372 14.2261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsercarEdit);
export default __webpack_public_path__ + "static/media/UsercarEdit.69e8f42033950167d3aa0fe0d86a3c75.svg";
export { ForwardRef as ReactComponent };